import { isEmptyJsonObject } from "../../../common/utils/helper";
import { callWithBasicAuth } from "../../../common/modules/http.bridge.client";
import { getCredentials } from "../common/util/wizard.auth";
import { getBridgeJiraBaseURL } from "../../../env/stage";

const simpleConnectionTest = async (credObj) => {
  try {
    await callWithBasicAuth(
      `${getBridgeJiraBaseURL()}/rest/api/latest/myself`,
      "GET",
      credObj,
      {}
    );
    return true;
  } catch (error) {
    return false;
  }
};

export const userNamePasswordNotEmpty = async (
  currentData,
  jiraAssetData,
  creds
) => {
  let status = true;
  let message = "";
  //console.log("userNamePasswordNotEmpty",currentData?.selectedAuthOption)
  if (currentData?.selectedAuthOption === "") {
    status = false;
    message = "Select or create a new credential.";
  } else if (currentData?.selectedAuthOption === "CredentialPicker") {
    if (isEmptyJsonObject(currentData?.credential)) {
      status = false;
      message = "Select a credential.";
    }
  } else if (currentData?.selectedAuthOption === "WizardBasicAuth") {
    if (
      currentData?.jiraUserEmail === "" &&
      currentData?.jiraUserPassword === ""
    ) {
      status = false;
      message = "Create a new credential.";
    }
  } else {
    status = false;
    message = "Please provide a Credential";
  }
  //return input validation
  if (!status) {
    return {
      valid: status,
      message: message,
    };
  }
  //try connect
  const connected = await simpleConnectionTest(
    getCredentials(currentData, creds)
  );
  return {
    valid: connected,
    message: connected
      ? ""
      : "Could not connect with credentials, please verify the credentials entered.",
  };
};
